import { render, staticRenderFns } from "./LoginMain.vue?vue&type=template&id=6308f26c&scoped=true&"
import script from "./LoginMain.vue?vue&type=script&lang=js&"
export * from "./LoginMain.vue?vue&type=script&lang=js&"
import style0 from "./LoginMain.vue?vue&type=style&index=0&id=6308f26c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6308f26c",
  null
  
)

export default component.exports